import type {
    PricingPagePropertyOnboardingContextFieldsV2,
    PricingPagePropertyOnboardingContextIdsV2,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    AddNewPayoutMethodElementPropertyOnboardingManifestV1,
    AgodaECardElementPropertyOnboardingManifestV1,
    BankTransferElementPropertyOnboardingManifestV1,
    ChannelManagerDropdownElementPropertyOnboardingManifestV1,
    EarningMethodElementPropertyOnboardingManifestV1,
    First3BookingPromotionElementPropertyOnboardingManifestV1,
    ListYourPropertyBackElementPropertyOnboardingManifestV1,
    ListYourPropertyNextElementPropertyOnboardingManifestV1,
    ListYourPropertyStepperElementPropertyOnboardingManifestV1,
    MinimumNightlyRateElementPropertyOnboardingManifestV1,
    MonthlyPromotionDiscountElementPropertyOnboardingManifestV1,
    MonthlyPromotionToggleElementPropertyOnboardingManifestV1,
    NightlyRateElementPropertyOnboardingManifestV1,
    PayoutDropdownElementPropertyOnboardingManifestV1,
    PaypalElementPropertyOnboardingManifestV1,
    SaveAndExitElementPropertyOnboardingManifestV1,
    SetChannelManagerElementPropertyOnboardingManifestV1,
    SetRateManuallyElementPropertyOnboardingManifestV1,
    UpcEPassElementPropertyOnboardingManifestV1,
    UpcElementPropertyOnboardingManifestV1,
    UseAnExistingPayoutMethodElementPropertyOnboardingManifestV1,
    WeeklyPromotionDiscountElementPropertyOnboardingManifestV1,
    WeeklyPromotionToggleElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import {
    PricingPagePropertyOnboardingContextManifestV2,
    WebListYourPropertyPricingVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/pricing-page";
import { BaseContextFieldsMapping, GetAttributeSafe } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const pricingBinder = defineBinder(({ webAnalytics, action: { click, reveal } }) => {
    webAnalytics.pageContext<PricingPagePropertyOnboardingContextIdsV2, PricingPagePropertyOnboardingContextFieldsV2>(
        PricingPagePropertyOnboardingContextManifestV2.ids,
        {
            auth_user_id: BaseContextFieldsMapping.auth_user_id,
            member_id: BaseContextFieldsMapping.member_id,
            property_id: BaseContextFieldsMapping.property_id,
            onboarding_id: BaseContextFieldsMapping.onboarding_id,
            is_internal_user: BaseContextFieldsMapping.is_internal_user,
        },
    );

    webAnalytics.observe(WebListYourPropertyPricingVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], ListYourPropertyNextElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyBackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyStepperElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "step-name"),
    });
    webAnalytics.observeElement([click], SaveAndExitElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], SetRateManuallyElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], NightlyRateElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], First3BookingPromotionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], WeeklyPromotionToggleElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], WeeklyPromotionDiscountElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], MonthlyPromotionToggleElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], MonthlyPromotionDiscountElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], EarningMethodElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "payment-method-name"),
    });
    webAnalytics.observeElement([click], SetChannelManagerElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], ChannelManagerDropdownElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "channel-manager-name"),
    });
    webAnalytics.observeElement([click, reveal], MinimumNightlyRateElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click, reveal], UseAnExistingPayoutMethodElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], PayoutDropdownElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "payout-name"),
    });
    webAnalytics.observeElement([click, reveal], AddNewPayoutMethodElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], UpcElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], UpcEPassElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], AgodaECardElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], BankTransferElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], PaypalElementPropertyOnboardingManifestV1.ids, {});
});
